import React from 'react'

const FinanceDashboard = () => {
    return (
        <div>I am the dashboard</div>
    )
}

export default FinanceDashboard
